import { AlertTriangle, Inbox, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Loading = ({ label = "Loading...", full = false }) => (
  <div data-testid="loading-state" className={`flex flex-col items-center justify-center gap-3 text-ink-3 ${full ? "min-h-screen" : "py-16"}`}>
    <Loader2 className="h-7 w-7 animate-spin text-aqua" />
    <p className="text-sm">{label}</p>
  </div>
);

export const EmptyState = ({ title, text, action, onAction, testId = "empty-state" }) => (
  <div data-testid={testId} className="flex flex-col items-start gap-3 rounded-xl border border-dashed border-line-strong bg-canvas-2/60 p-8">
    <Inbox className="h-7 w-7 text-ink-3" />
    <h3 className="text-lg font-semibold text-ink">{title}</h3>
    {text && <p className="max-w-md text-sm text-ink-2">{text}</p>}
    {action && <Button data-testid={`${testId}-action`} onClick={onAction} className="mt-1">{action}</Button>}
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div data-testid="error-state" className="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 p-5 text-red-800">
    <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
    <div className="flex-1">
      <p className="text-sm font-medium">{message}</p>
      {onRetry && <Button data-testid="error-retry-btn" variant="outline" size="sm" className="mt-3" onClick={onRetry}>Try again</Button>}
    </div>
  </div>
);

export const PageHeader = ({ eyebrow, title, text, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {eyebrow && <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-aqua">{eyebrow}</p>}
      <h1 className="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">{title}</h1>
      {text && <p className="mt-2 max-w-2xl text-sm text-ink-2 sm:text-base">{text}</p>}
    </div>
    {children}
  </div>
);
